import type { MouseEventHandler } from "react";
import type { TWithDataComponent } from "@/ui/lib/types";
import { type Allergen, type CatMedicalCondition } from "@/primary-models";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const CAT_MEDICAL_CARD_ARTICLE_CLASS =
  "w-full rounded-sys-sm border border-component-card-base p-4 shadow-sm shadow-sys-outline-dark";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TCatMedicalCardProps = TWithDataComponent & {
  allergies: Allergen[] | null;
  medicalConditions: CatMedicalCondition[] | null;
  onEdit: MouseEventHandler<HTMLButtonElement>;
};

export type TUseCatMedicalCardProps = Omit<TCatMedicalCardProps, "onEdit">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const CAT_MEDICAL_CARD_DEFAULTS = {
  "data-component": "CatMedicalCard",
} as const;
